import {useState} from "react";
import AdsTypeCard from "../../ui/adstypecard/adstypecard";
import "./adstypebox.scss"
import ScrollTab from "../../ui/tab/scrolltab/scrolltab";
import {TabFormat} from "../../modals/types/tab";

interface IAdsTypeBox {
    scrollTabItems: TabFormat[]
    adsTypeCardNames:string[]
}

const AdsTypeBox = ({scrollTabItems,adsTypeCardNames}: IAdsTypeBox) => {
    const [activate, setActivate] = useState("tab0");

    return (
        <div className="Ads-Type-Box">
            <div className="container-fluid">
                <div className="container">
                    <div className="row pe-lg-4 pe-md-2">
                        {
                            adsTypeCardNames.map((adsTypeCardsName,index) => {
                                return (
                                    <div key={index}
                                        className="col-lg-4 col-md-4 col-12 mb-3 d-flex justify-content-center">
                                        <AdsTypeCard name={adsTypeCardsName} setActivate={setActivate} id={index} activate={activate}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className="Tab-Elements-Container">
                    <ScrollTab tabs={scrollTabItems[parseInt(activate.substring(3, 4))].tabs}
                               tabPanel={scrollTabItems[parseInt(activate.substring(3, 4))].tabPanel}/>
                </div>
            </div>
        </div>
    );
}

export default AdsTypeBox;